import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { CapabilitiesGrid } from './components/CapabilitiesGrid';
import { HowItWorks } from './components/HowItWorks';
import { SolutionsSegments } from './components/SolutionsSegments';
import { TrustCompliance } from './components/TrustCompliance';
import { ImpactMetrics } from './components/ImpactMetrics';
import { Testimonial } from './components/Testimonial';
import { GrantsCallout } from './components/GrantsCallout';
import { Insights } from './components/Insights';
import { LeadForm } from './components/LeadForm';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-iris-black text-iris-text font-body selection:bg-iris-green selection:text-white" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <Nav data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <CapabilitiesGrid data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <SolutionsSegments data-id="element-8" />
        <TrustCompliance data-id="element-9" />
        <ImpactMetrics data-id="element-10" />
        <Testimonial data-id="element-11" />
        <GrantsCallout data-id="element-12" />
        <Insights data-id="element-13" />
        <LeadForm data-id="element-14" />
        <Faq data-id="element-15" />
        <FinalCta data-id="element-16" />
      </main>

      <Footer data-id="element-17" />
    </div>;
}